import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import * as Sentry from "@sentry/browser";

import { loginActions } from "../../../redux/actions";
import { textStrings } from "../../../constants";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { id, name, email } = this.props.user;

    // Report the error with the affected user's details.
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      scope.setUser({
        id: id,
        username: name,
        email: email,
      });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="not-found">
          <div className="not-found__content">
            <h3 className="not-found__info">
              {textStrings.ERROR_BOUNDARY_MESSAGE}
            </h3>
            <Button variant="primary" onClick={() => loginActions.logout()}>
              {textStrings.BACK_TO_LOGIN}
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

//Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  user: state.authentication.user,
});

//Mapping action and store the function via props
export default connect(mapStateToProps, null)(ErrorBoundary);
